<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";
export default {
  name: "MaterialFieldsRack",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin, unitConverterMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },
    /**
     * Indicates if the fields should be disabled or not
     */
    disableFields: {
      type: Boolean
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  /**
   * Executed when the component is mounted
   * It's a preemptive verification
   *
   */
  mounted() {
    // temporary values while the fields are not visible in the form
    if (!this.familySpecificFields.smrc_network_level) {
      this.familySpecificFields.smrc_network_level = "1";
    }
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("Height") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smrc_height,
          varName: 'smrc_height',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '.01',
          min: '1',
        },
        {
          label: this.$i18n.t("Width") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smrc_width,
          varName: 'smrc_width',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '.01',
          min: '1',
        },
        {
          label: this.$i18n.t("Depth") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smrc_depth,
          varName: 'smrc_depth',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '.01',
          min: '1',
        },
        {
          label: this.$i18n.t("Capacity") + ' (U)',
          value: this.familySpecificFields.smrc_capacity,
          varName: 'smrc_capacity',
          inputType: 'number',
          disabled: false,
          required: true,
          step: '1',
          min: '1',
        },
      ]
    },
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.smrc_height && this.familySpecificFields.smrc_height >= 1 &&
        !!this.familySpecificFields.smrc_width && this.familySpecificFields.smrc_width >= 1 &&
        !!this.familySpecificFields.smrc_depth && this.familySpecificFields.smrc_depth >= 1 &&
        !!this.familySpecificFields.smrc_capacity && this.familySpecificFields.smrc_capacity >= 1
      );
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsRack.vue